import { namespacer } from 'helpers'

const namespace = namespacer('EMAIL_CONFIRMATION')

export const CONFIRM_EMAIL_SUCCESS = namespace('CONFIRM_EMAIL_SUCCESS')
export const CONFIRM_EMAIL_FAIL = namespace('CONFIRM_EMAIL_FAIL')
